(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/league-nhl/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/themes/league-nhl/assets/javascripts/init.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.league_nhl = svs.themes.league_nhl || {};

  var log = new svs.core.log.Logger('svs.themes.league_nhl.init');

  svs.themes.league_nhl.init = function(func, params) {
    if (!_.isArray(params)) {
      params = [params];
    }

    if (typeof svs.themes.league_nhl[func] === 'function') {
      return svs.themes.league_nhl[func].apply(svs.themes.league_nhl, params);
    }
    log.debug('function ' + func + ' does not exist in this theme');
  };
})(svs);

 })(window);